<template>
  <!-- 人员看板 -->
  <div class="staffBoard">
    <!-- 头部 -->
    <div class="head">
      <!-- 项目区域 -->
      <div class="projectRegion">
        <span>项目区域：</span>
        <div class="regions">
          <el-button type="primary" size="mini" :plain="region !== ''" @click="region = ''">全部</el-button>
          <el-button v-for="item in cityRegions" :key="item.code" type="primary" size="mini"
            :plain="region !== item.code" @click="region = item.code">
            {{ item.name }}
          </el-button>

          <div v-if="!regionOpen && prjAreaList.length > 6" class="Btn" @click="regionOpen = true">
            <span>展开</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div v-if="regionOpen" class="Btn" @click="regionOpen = false">
            <span>收起</span>
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
      </div>
      <!-- 项目时间 -->
      <div class="projectDate">
        <span>项目时间：</span>
        <el-date-picker v-model="projectDate" :picker-options="pickerOptions" type="daterange" size="small" align="right"
          start-placeholder="开始时间" range-separator="至" end-placeholder="结束时间" unlink-panels>
        </el-date-picker>

        <el-button size="small" style="margin-left: 20px;" plain @click="resetting">重置</el-button>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
    </div>

    <!-- 人员项目统计 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>人员项目统计</span>
      </div>
      <div class="title_right">
        <span>所属部门：</span>
        <el-cascader ref="departmentProject" v-model="departmentProject" :options="departments" size="small" clearable
          placeholder="全部" :props="{value: 'deptId', label: 'deptName', children: 'children', checkStrictly: true}"
          @change="projectChart_setOption">
        </el-cascader>
      </div>
    </div>
    <div class="board">
      <!-- 人员项目统计图 -->
      <div id="projectChart" ref="projectChart" class="slider"></div>
    </div>

    <!-- 人员问题统计 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>人员问题统计</span>
      </div>
      <div class="title_right">
        <span>所属部门：</span>
        <el-cascader ref="departmentQue" v-model="departmentQue" :options="departments" size="small" clearable
          placeholder="全部" :props="{value: 'deptId', label: 'deptName', children: 'children', checkStrictly: true}"
          @change="QueChart_setOption">
        </el-cascader>
      </div>
    </div>
    <!-- 问题类型选择 -->
    <div class="questionType">
      <el-radio-group v-model="questionType" size="small" @change="QueChart_setOption">
        <el-radio-button label="3">2D</el-radio-button>
        <el-radio-button label="1">3D</el-radio-button>
        <el-radio-button label="0">文件</el-radio-button>
      </el-radio-group>
    </div>
    <div class="board">
      <!-- 人员问题统计图 -->
      <div id="QueChart" ref="QueChart" class="slider"></div>
    </div>

    <!-- 人员状态统计 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>人员状态统计</span>
      </div>
      <div class="title_right" style="height: 28px"></div>
    </div>
    <div class="board">
      <!-- 人员状态统计图 -->
      <div id="statusChart" ref="statusChart" class="slider"></div>
    </div>

    <!-- 人员工时统计 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>人员工时统计</span>
      </div>
    </div>
    <!-- 问题类型选择 -->
    <div class="questionType">
      <span>所属部门：</span>
      <el-cascader ref="departmentWorkTime" v-model="departmentWorkTime" :options="departments" size="small" clearable
        placeholder="全部" :props="{value: 'deptId', label: 'deptName', children: 'children', checkStrictly: true}"
        @change="personnelHoursChart_setOption">
      </el-cascader>
      <span style="margin-left:20px">起止时间：</span>
      <el-date-picker v-model="time" :picker-options="pickerOptions" type="daterange" size="small" align="right"
        start-placeholder="开始时间" range-separator="至" end-placeholder="结束时间" unlink-panels :clearable="false" @change="personnelHoursChart_setOption">
      </el-date-picker>
    </div>
    <div class="board" style="margin-bottom: 0">
      <!-- 人员工时统计图 -->
      <div id="personnelHoursChart" ref="personnelHoursChart" class="slider"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dataBoardService from "@/CommonDP/service/dataBoard-service.js";
import moment from "moment";
import * as echarts from 'echarts';
var projectChart; // 人员项目统计图
var QueChart; // 人员问题统计图
var statusChart; // 人员状态统计图
var personnelHoursChart; // 人员工时统计图

export default {
  components: {},
  data() {
    return {
      prjAreaList: [], // 项目区域数据
      departments: [], // 部门

      region: "", // 项目区域
      regionOpen: false, // 项目区域展开
      projectDate: "", // 选择项目时间

      departmentProject: [],
      personnelPrjNum: [], // 人员项目统计数据

      departmentQue: [],
      questionType: "3", // 当前问题类型：	2D问题，3D问题，文件问题
      personnelQuestionNum: [], // 人员问题统计数据

      personnelStatusNum: [], // 人员状态统计数据
      personnelHoursNum: [], // 人员工时统计

      pickerOptions: {
        // 日期选择快捷键
        shortcuts: [
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      departmentWorkTime: [],
      time: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()]
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),

    // 开始时间
    startDate() {
      if (this.projectDate && this.projectDate.length > 0) {
        return moment(this.projectDate[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    endDate() {
      if (this.projectDate && this.projectDate.length > 1) {
        return moment(this.projectDate[1]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },

    // 城市区域
    cityRegions() {
      let provinces = this.prjAreaList;
      provinces = provinces.filter((item) => item.name);
      provinces = provinces.map((item) => {
        const city = { ...item };
        let name = item.name;
        name = name.replace("市", "");
        city.name = name;
        return city;
      });
      if (!this.regionOpen && this.prjAreaList.length > 6) {
        return provinces.slice(0, 6);
      } else {
        return provinces;
      }
    },
    // 开始时间
    startTime() {
      if (this.time && this.time.length > 0) {
        return moment(this.time[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    endTime() {
      if (this.time && this.time.length > 1) {
        return moment(this.time[1]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    }
  },
  watch: {
    region() {
      this.$nextTick(() => {
        this.search();
      });
    }
  },
  mounted() {
    this.getPrjAreaList();
    this.getDepartments();

    this.projectChart_init();
    this.QueChart_init();
    this.statusChart_init();
    this.personnelHoursChart_init();
  },
  methods: {
    // 查询项目区域+区域内项目数量
    async getPrjAreaList() {
      const params = {
        enterpriseId: this.enterpriseId
      };
      const res = await dataBoardService.getPrjAreaList(params);
      this.prjAreaList = res.data;
    },

    // 获得部门
    async getDepartments() {
      const res = await dataBoardService.getDepartments(this.enterpriseId);
      this.departments = this.getTreeData(res.data);
    },

    // 递归判断列表，把最后的children设为undefined
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },

    // 人员项目统计数据
    async getPersonnelPrjNum() {
      const params = {
        enterpriseId: this.enterpriseId,
        cityCode: this.region || "", // 	城市编码
        deptId: this.departmentProject[this.departmentProject.length - 1] || "", // 部门id
        startDate: this.startDate, // 开始时间
        endDate: this.endDate // 结束时间
      };
      const res = await dataBoardService.getPersonnelPrjNum(params);
      this.personnelPrjNum = res.data;
    },

    // 人员项目统计_初始化
    projectChart_init() {
      projectChart = echarts.init(this.$refs.projectChart);
      this.projectChart_setOption();
    },

    // 人员项目统计_加载数据
    projectChart_setOption() {
      this.getPersonnelPrjNum().then(() => {
        const x_users = this.personnelPrjNum.map((item) => item.name);
        const prjTotalNum = this.personnelPrjNum.map((item) => item.prjTotalNum);
        const inProgressPrjNum = this.personnelPrjNum.map((item) => item.inProgressPrjNum);
        const option = {
          // 图例
          legend: {
            orient: "horizontal", // 水平布局
            bottom: "0%",
            x: "center",
            itemGap: 50, // 间隔
            data: ["项目总数", "进行中的项目"]
          },
          // x轴
          xAxis: [
            {
              type: "category",
              offset: 6,
              data: x_users,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#DCDCDC"
                }
              }, // 轴线
              axisLabel: { color: "#646464", fontSize: "14px" }, // 标签颜色和大小
              axisTick: {
                show: false
              } // 刻度
            }
          ],
          // y轴
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DCDCDC"
              }
            }, // 轴线
            axisLabel: { color: "#646464" }, // 标签
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#F5F5F5"
              }
            } // 分割线
          },
          // 坐标轴定位
          grid: {
            top: "5%",
            width: "100%",
            left: "0",
            containLabel: true
          },
          // 滚动滑块
          dataZoom: [
            {
              startValue: 0,
              endValue: 9,
              zoomLock: false, // 锁定滑块大小
              handleSize: 6,
              showDetail: false, // 滑块两端信息
              showDataShadow: false, // 数据阴影可以简单地反应数据走势
              brushSelect: false,
              show: true,
              height: 6,
              right: 6,
              backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
              borderColor: "rgb(0 0 0 0.3);", // 边框颜色
              fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
              handleIcon: "circle", // 滑块两端圆形
              handleStyle: {
                color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                borderWidth: 0
              }
            }
          ],
          // 列表
          series: [
            {
              name: "项目总数",
              type: "bar",
              barWidth: 20, // 柱图宽度
              data: prjTotalNum
            },
            {
              name: "进行中的项目",
              type: "bar",
              barWidth: 22, // 柱图宽度
              data: inProgressPrjNum
            }
          ],
          // 提示
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [15, 20, 15, 15],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px",
            axisPointer: {
              type: "shadow"
            }
          }
        };
        if (x_users.length < 11) option.dataZoom = [];
        projectChart.setOption(option, true);
      });
    },

    // 人员问题统计数据
    async getPersonnelQuestionNum() {
      const params = {
        enterpriseId: this.enterpriseId,
        category: this.questionType,
        cityCode: this.region || "", // 	城市编码
        deptId: this.departmentQue[this.departmentQue.length - 1] || "", // 部门id
        startDate: this.startDate, // 开始时间
        endDate: this.endDate // 结束时间
      };
      const res = await dataBoardService.getPersonnelQuestionNum(params);
      this.personnelQuestionNum = res.data;
    },

    // 人员问题统计_初始化
    QueChart_init() {
      QueChart = echarts.init(this.$refs.QueChart);
      this.QueChart_setOption();
    },

    // 人员问题统计_加载数据
    QueChart_setOption() {
      this.getPersonnelQuestionNum().then(() => {
        const x_users = this.personnelQuestionNum.map((item) => item.name);
        const createNum = this.personnelQuestionNum.map((item) => item.createNum);
        const modifiedNum = this.personnelQuestionNum.map((item) => item.modifiedNum);
        const option = {
          // 图例
          legend: {
            orient: "horizontal", // 水平布局
            bottom: "0%",
            x: "center",
            itemGap: 50, // 间隔
            data: ["创建问题数", "修改问题数"]
          },
          // x轴
          xAxis: [
            {
              type: "category",
              offset: 6,
              data: x_users,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#DCDCDC"
                }
              }, // 轴线
              axisLabel: { color: "#646464", fontSize: "14px" }, // 标签颜色和大小
              axisTick: {
                show: false
              } // 刻度
            }
          ],
          // y轴
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DCDCDC"
              }
            }, // 轴线
            axisLabel: { color: "#646464" }, // 标签
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#F5F5F5"
              }
            } // 分割线
          },
          // 坐标轴定位
          grid: {
            top: "5%",
            width: "100%",
            left: "0",
            containLabel: true
          },
          // 滚动滑块
          dataZoom: [
            {
              startValue: 0,
              endValue: 9,
              zoomLock: false, // 锁定滑块大小
              handleSize: 6,
              showDetail: false, // 滑块两端信息
              showDataShadow: false, // 数据阴影可以简单地反应数据走势
              brushSelect: false,
              show: true,
              height: 6,
              right: 6,
              backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
              borderColor: "rgb(0 0 0 0.3);", // 边框颜色
              fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
              handleIcon: "circle", // 滑块两端圆形
              handleStyle: {
                color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                borderWidth: 0
              }
            }
          ],
          // 列表
          series: [
            {
              name: "创建问题数",
              type: "bar",
              barWidth: 20, // 柱图宽度
              data: createNum
            },
            {
              name: "修改问题数",
              type: "bar",
              barWidth: 22, // 柱图宽度
              data: modifiedNum
            }
          ],
          // 提示
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [15, 20, 15, 15],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px",
            axisPointer: {
              type: "shadow"
            }
          }
        };
        if (x_users.length < 8) option.dataZoom = [];
        QueChart.setOption(option, true);
      });
    },

    // 人员状态统计数据
    async getPersonnelStatusNum() {
      const params = {
        enterpriseId: this.enterpriseId,
        cityCode: this.region || "", // 	城市编码
        startDate: this.startDate, // 开始时间
        endDate: this.endDate // 结束时间
      };
      const res = await dataBoardService.getPersonnelStatusNum(params);
      this.personnelStatusNum = res.data;
    },

    // 人员状态统计_初始化
    statusChart_init() {
      statusChart = echarts.init(this.$refs.statusChart);
      this.statusChart_setOption();
    },

    // 人员状态统计_加载数据
    statusChart_setOption() {
      this.getPersonnelStatusNum().then(() => {
        const x_users = this.personnelStatusNum.map((item) => item.deptName);
        const peopleNum = this.personnelStatusNum.map((item) => item.peopleNum);
        const disablePeopleNum = this.personnelStatusNum.map((item) => item.disablePeopleNum);
        const option = {
          color: ["#639BFF", "#FE838C"],
          // 图例
          legend: {
            orient: "horizontal", // 水平布局
            bottom: "0%",
            x: "center",
            itemGap: 50, // 间隔
            data: ["人员总数", "禁用人数"]
          },
          // x轴
          xAxis: [
            {
              type: "category",
              offset: 6,
              data: x_users,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#DCDCDC"
                }
              }, // 轴线
              axisLabel: { color: "#646464", fontSize: "14px" }, // 标签颜色和大小
              axisTick: {
                show: false
              } // 刻度
            }
          ],
          // y轴
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DCDCDC"
              }
            }, // 轴线
            axisLabel: { color: "#646464" }, // 标签
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#F5F5F5"
              }
            } // 分割线
          },
          // 坐标轴定位
          grid: {
            top: "5%",
            width: "100%",
            left: "0",
            containLabel: true
          },
          // 滚动滑块
          dataZoom: [
            {
              startValue: 0,
              endValue: 9,
              zoomLock: false, // 锁定滑块大小
              handleSize: 6,
              showDetail: false, // 滑块两端信息
              showDataShadow: false, // 数据阴影可以简单地反应数据走势
              brushSelect: false,
              show: true,
              height: 6,
              right: 6,
              backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
              borderColor: "rgb(0 0 0 0.3);", // 边框颜色
              fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
              handleIcon: "circle", // 滑块两端圆形
              handleStyle: {
                color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                borderWidth: 0
              }
            }
          ],
          // 列表
          series: [
            {
              name: "人员总数",
              type: "bar",
              barWidth: 20, // 柱图宽度
              data: peopleNum
            },
            {
              name: "禁用人数",
              type: "bar",
              barWidth: 22, // 柱图宽度
              data: disablePeopleNum
            }
          ],
          // 提示
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [15, 20, 15, 15],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px",
            axisPointer: {
              type: "shadow"
            }
          }
        };
        if (x_users.length < 8) option.dataZoom = [];
        statusChart.setOption(option, true);
      });
    },
    // 人员工时统计数据
    async getPersonnelPersonnelHoursNum() {
      const params = {
        enterpriseId: this.enterpriseId,
        deptId: this.departmentWorkTime[this.departmentWorkTime.length - 1] || "", // 部门id
        startDate: this.startTime, // 开始时间
        endDate: this.endTime // 结束时间
      };
      const res = await dataBoardService.getPersonnelPersonnelHoursNum(params);
      this.personnelHoursNum = res.data;
    },
    // 人员工时统计_初始化
    personnelHoursChart_init() {
      personnelHoursChart = echarts.init(this.$refs.personnelHoursChart);
      this.personnelHoursChart_setOption();
    },
    // 人员工时统计_加载数据
    personnelHoursChart_setOption() {
      this.getPersonnelPersonnelHoursNum().then(() => {
        const x_users = this.personnelHoursNum.map((item) => item.name);
        const hoursNum = this.personnelHoursNum.map((item) => item.workTime);
        const option = {
          // x轴
          xAxis: [
            {
              type: "category",
              offset: 6,
              data: x_users,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#DCDCDC"
                }
              }, // 轴线
              axisLabel: { color: "#646464", fontSize: "14px" }, // 标签颜色和大小
              axisTick: {
                show: false
              } // 刻度
            }
          ],
          // y轴
          yAxis: {
            type: "value",
            name: '(h)',
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DCDCDC"
              }
            }, // 轴线
            axisLabel: { color: "#646464" }, // 标签
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#F5F5F5"
              }
            } // 分割线
          },
          // 坐标轴定位
          grid: {
            top: "8%",
            width: "100%",
            left: "0",
            containLabel: true
          },
          // 滚动滑块
          dataZoom: [
            {
              startValue: 0,
              endValue: 9,
              zoomLock: false, // 锁定滑块大小
              handleSize: 6,
              showDetail: false, // 滑块两端信息
              showDataShadow: false, // 数据阴影可以简单地反应数据走势
              brushSelect: false,
              show: true,
              height: 6,
              right: 6,
              backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
              borderColor: "rgb(0 0 0 0.3);", // 边框颜色
              fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
              handleIcon: "circle", // 滑块两端圆形
              handleStyle: {
                color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                borderWidth: 0
              }
            }
          ],
          // 列表
          series: [
            {
              name: "总工时(h)",
              type: "bar",
              barWidth: 20, // 柱图宽度
              data: hoursNum
            }
          ],
          // 提示
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [15, 20, 15, 15],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px",
            axisPointer: {
              type: "shadow"
            }
          }
        };
        if (x_users.length < 8) option.dataZoom = [];
        personnelHoursChart.setOption(option, true);
      });
    },

    // 查询
    search() {
      this.projectChart_setOption();
      this.QueChart_setOption();
      this.statusChart_setOption();
    },
    resetting() {
      this.projectDate = '';
      this.search();
    },

    // 导出PPT
    async exportPPT() {
      let deptName1 = "全部";
      let deptName2 = "全部";
      const node1 = this.$refs.departmentProject.getCheckedNodes()[0];
      if (node1) deptName1 = node1.pathLabels.join("/");
      const node2 = this.$refs.departmentQue.getCheckedNodes()[0];
      if (node2) deptName2 = node2.pathLabels.join("/");

      const params = {
        dashboard: 3, // 人员看板固定 3
        condition: {
          enterpriseId: this.enterpriseId,
          category: this.questionType,
          cityCode: this.region,
          startDate: this.startDate,
          endDate: this.endDate
        }, // 顶部查询条件
        slideList: [
          {
            title: "人员项目统计",
            deptName: deptName1,
            chartBase64List: ["{{" + this.createBase64("#projectChart") + "}}"]
          },
          {
            title: "人员问题统计",
            deptName: deptName2,
            chartBase64List: ["{{" + this.createBase64("#QueChart") + "}}"]
          },
          {
            title: "人员状态统计",
            chartBase64List: ["{{" + this.createBase64("#statusChart") + "}}"]
          }
        ]
      };
      const res = await dataBoardService.exportPPT(params);
      const fileName = "人员看板.pptx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // echarts图表转化为base64
    createBase64(ele) {
      const docEle = ele + " canvas";
      const canvasFixed = document.querySelector(docEle); // 获取图表元素
      const canvasWidth = canvasFixed.width; // 获取图表元素宽度
      const canvasHeigth = canvasFixed.heigth; // 获取图表元素高度
      const canvas2D = canvasFixed.getContext("2d");
      canvas2D.drawImage(canvasFixed, canvasWidth, canvasHeigth);
      return canvasFixed.toDataURL();
    },
    // 导出excel
    async exportExcel() {
      const params = {
        dashboard: 3, // 人员看板固定 3
        condition: {
          enterpriseId: this.enterpriseId,
          cityCode: this.region,
          startDate: this.startDate,
          endDate: this.endDate
        }, // 顶部查询条件
        conditionArray: [
          { deptId: this.departmentProject[this.departmentProject.length - 1] || "" },
          { deptId: this.departmentQue[this.departmentQue.length - 1] || "", category: this.questionType }
        ]
      };
      const res = await dataBoardService.exportExcel(params);
      const fileName = "人员看板.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.staffBoard {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .head {
    width: 100%;
    padding: var(--big-space);
    border-radius: 0 0 4px 4px;
    background-color: white;
    margin-bottom: var(--middle-space);

    .projectRegion {
      width: 100%;
      display: flex;

      span {
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;
        font-family: "Microsoft YaHei UI";
        color: var(--key-color);
      }

      .regions {
        width: calc(100% - 80px);
        display: flex;
        align-items: center;
        flex-flow: wrap;

        .el-button {
          padding: 7px 18px;
          border: none;
          margin: 5px 0;
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
        }

        /deep/ .el-button--primary.is-plain {
          background: #eef3fd !important;
          color: #4777e7 !important;
        }

        .Btn {
          margin-left: 20px;
          white-space: nowrap;
          cursor: pointer;

          display: flex;
          align-items: center;

          span {
            color: var(--theme-color);
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 28px;
          }

          i {
            padding: 0 4px;
            color: var(--theme-color);
          }
        }
      }
    }

    .projectDate {
      width: 100%;
      padding: var(--middle-space) 0;
      display: flex;
      align-items: center;

      span {
        font-family: "Microsoft YaHei UI";
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
        color: var(--key-color);
        white-space: nowrap;
      }
    }
  }

  .title {
    width: 100%;
    padding: var(--small-space) var(--big-space);
    border-bottom: 1px solid #e6eaf8;
    border-radius: 4px 4px 0 0;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title_left {
      display: flex;
      align-items: center;

      .el-divider {
        background-color: var(--theme-color);
        width: 3px;
        height: 15px;
        margin: 0 8px 0 0;
      }

      span {
        font-size: 16px;
        line-height: 28px;
        font-weight: 700;
        color: var(--key-color);
        white-space: nowrap;
      }
    }

    .title_right {
      display: flex;
      align-items: center;

      span {
        font-family: "Microsoft YaHei UI";
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: var(--common-color);
        white-space: nowrap;
        padding-left: 25px;
      }
    }
  }

  .board {
    width: 100%;
    padding: 40px 30px;
    border-radius: 0 0 4px 4px;
    background-color: white;
    margin-bottom: var(--middle-space);
    display: flex;
    justify-content: center;
    align-items: center;

    .slider {
      width: 1440px;
      height: 360px;
    }
  }

  .questionType {
    width: 100%;
    padding: 20px 30px 0;
    background-color: white;
  }
}
</style>
